import React, { useState, useEffect } from "react";
import { awsUrl2 } from "../../../config";
import { Auth } from "../../../utils/amplifyAuth";
import axios from "axios";
import SmallLoader from "../../../newcomponent/common/smallLoader";
// Define the component
const DownloadEAcord = (props) => {
  // State declaration using useState hook
  const { selectedCarrier, stateTableData, updatePopUpData, disabledDropDown } =
    props;
  const states = Object.keys(stateTableData);
  const [loadingEAcordNCCI, setLoadingEAcordNCCI] = useState(false);
  const [loadingEAcordCA, setLoadingEAcordCA] = useState(false);
  const [loadingEAcordFL, setLoadingEAcordFL] = useState(false);
  const not_include_in_ncci = ["oh", "wa", "wy", "nd", "fl", "ca"];
  const [statesMap, setStatesMap] = useState({
    ncci: {
      available: false,
      stateList: [],
    },
    ca: {
      available: false,
      stateList: [],
    },
    fl: {
      available: false,
      stateList: [],
    },
  });

  useEffect(() => {
    const result = JSON.parse(JSON.stringify(statesMap));
    states.forEach((state) => {
      switch (state) {
        case "ca":
          result.ca.stateList.push(state.toUpperCase());
          result.ca.available = true;
          break;
        case "fl":
          result.fl.stateList.push(state.toUpperCase());
          result.fl.available = true;
          break;
        default:
          if (!not_include_in_ncci.includes(state)) {
            result.ncci.stateList.push(state.toUpperCase());
            result.ncci.available = true;
          }
          break;
      }
    });
    console.log("setStatesMap", states, result);
    setStatesMap(result);
  }, [stateTableData, selectedCarrier]);

  const handleDownloadPopup = async (acordType) => {
    updatePopUpData({
      show: true,
      title: "Note",
      children: (
        <>
          <br></br>
          <span style={{ fontWeight: "bold" }}>
            Eacord may not work as intended in other browsers. For the best
            experience, please use Google Chrome.
          </span>
        </>
      ),
      acceptBtn: "Ok",
      acceptBtnCallback: async () => {
        try {
          // setEAcordDisabled(true);
          await downloadEAcord(acordType);
          // setEAcordDisabled(false);
        } catch (error) {
          console.log("error: ", error);
          // setEAcordDisabled(false);
        }
      },
      disableNoButton: true,
    });
  };
  /**
   * Helper: Polls the status API until the PDF is ready or fails
   */
  const pollStatus = async (uuid) => {
    const pollInterval = 3000; // 3 seconds
    const maxAttempts = 20; // 1 minute timeout
    let attempts = 0;

    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        attempts++;
        try {
          // Calling your new pollEAcordRequest endpoint
          // const response = await axios.post(
          //   `http://localhost:3000/dev/api/pollEAcordStatus`,
          //   { uuid },
          // );
          const response = await axios.post(`${awsUrl2}/api/pollEAcordStatus`, {
            uuid,
          });

          const { status, signedUrl } = response.data;

          console.log(`Polling status: ${status} (Attempt ${attempts})`);

          if (status === "completed") {
            clearInterval(interval);
            resolve(signedUrl);
          } else if (status === "failed") {
            clearInterval(interval);
            reject(new Error("PDF generation failed on server."));
          } else if (attempts >= maxAttempts) {
            clearInterval(interval);
            reject(new Error("Polling timed out."));
          }
        } catch (err) {
          console.error("Error during status poll:", err);
          // We don't clear interval here in case of temporary network flicker
        }
      }, pollInterval);
    });
  };

  /**
   * Main Function: Updates state, initiates request, and manages polling
   */
  const downloadEAcord = async (acordType) => {
    // 1. Set Loading States
    if (acordType === "ca") setLoadingEAcordCA(true);
    if (acordType === "ncci") setLoadingEAcordNCCI(true);
    if (acordType === "fl") setLoadingEAcordFL(true);

    try {
      // 2. Data Preparation
      let quoteData = JSON.parse(sessionStorage.getItem("quoteData"));
      let isLoggedIn = await Auth.currentAuthenticatedUser();
      let emailID = isLoggedIn.attributes.email;
      let address = sessionStorage.getItem("address");
      const carrier = selectedCarrier;
      let currProspectDetails = JSON.parse(
        sessionStorage.getItem("currProspect"),
      );

      let etQuoteDetails = {
        email: sessionStorage.getItem("user_id"),
        timestamp: quoteData.date,
        carrier,
        mail_address: "",
        address: address,
        state: statesMap[acordType].stateList,
        peo: currProspectDetails?.peoDetails?.selectedPeo,
        selectedKey: props.selectedPeo || currProspectDetails?.peoDetails?.selectedPeo,
        producerDetails: {
          producerName:
            currProspectDetails?.["companyProfile"]?.["producer"]?.["value"] ||
            "Paul Hughes",
          producerEmail: emailID,
          producerFax: " ",
          producerPhone: " ",
          producerMobile: " ",
        },
      };

      console.log("etQuoteDetails", etQuoteDetails);

      // 3. Initiate Request
      // This hits your 'inititateEAcordRequest' Lambda
      // const initRes = await axios.post(
      //   `http://localhost:3000/dev/api/generateEAcord${acordType.toUpperCase()}`,
      //   JSON.stringify(etQuoteDetails),
      // );

      const initRes = await axios.post(
        `${awsUrl2}/api/generateEAcord${acordType.toUpperCase()}`,
        JSON.stringify(etQuoteDetails),
      );

      const { uuid } = initRes.data;
      console.log("Received UUID from initiation response:", uuid);
      if (!uuid) throw new Error("Did not receive UUID from server.");

      // 4. Poll for completion
      const signedUrl = await pollStatus(uuid);

      // 5. Trigger Download
      const filename = `editable_acord_${acordType.toUpperCase()}_${carrier}.pdf`;
      const response = await fetch(signedUrl);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 6. Cleanup (Optional: deletes from S3 after download)
      await axios.delete(`${awsUrl2}/api/deleteEAcord?url=${signedUrl}`);
    } catch (error) {
      console.error("E-Acord Flow Error:", error);
      alert(`Could not generate PDF: ${error.message}`);
    } finally {
      // 7. Reset Loading States
      if (acordType === "ca") setLoadingEAcordCA(false);
      if (acordType === "ncci") setLoadingEAcordNCCI(false);
      if (acordType === "fl") setLoadingEAcordFL(false);
    }
  };

  // Component JSX
  return (
    <>
      {/* <h1>Hello, World!</h1> */}
      <div className="btnAlignDow">
        {/*  */}
        <div class="btn-group d-flex justify-content-center align-items-center">
          <button
            type="button"
            class="btn dropdown-toggle download-dropdown"
            data-bs-toggle="dropdown"
            data-bs-display="static"
            aria-expanded="false"
            disabled={disabledDropDown}
          >
            Download EAcord
          </button>
          <ul class="dropdown-menu">
            {statesMap["ncci"].available && (
              <li>
                <a class="dropdown-item" href="#">
                  <button
                    // className="btn btn-warning btn-lg btn-warning-shadow btnSubmits"
                    onClick={() => handleDownloadPopup("ncci")}
                    disabled={!selectedCarrier || loadingEAcordNCCI}
                    className="eacord-btn-disable"
                  >
                    {loadingEAcordNCCI
                      ? "Downloading NCCI EAcord..."
                      : "Download NCCI EAcord"}
                  </button>
                </a>
              </li>
            )}
            {statesMap["ca"].available && (
              <li>
                <a class="dropdown-item" href="#">
                  <button
                    // className="btn btn-warning btn-lg btn-warning-shadow btnSubmits"
                    onClick={() => handleDownloadPopup("ca")}
                    disabled={!selectedCarrier || loadingEAcordCA}
                    className="eacord-btn-disable"
                  >
                    {loadingEAcordCA
                      ? "Downloading CA EAcord..."
                      : "Download CA EAcord"}
                  </button>
                </a>
              </li>
            )}
            {statesMap["fl"].available && (
              <li>
                <a class="dropdown-item" href="#">
                  <button
                    // className="btn btn-warning btn-lg btn-warning-shadow btnSubmits"
                    onClick={() => handleDownloadPopup("fl")}
                    disabled={!selectedCarrier || loadingEAcordFL}
                    className="eacord-btn-disable"
                  >
                    {loadingEAcordFL
                      ? "Downloading FL EAcord..."
                      : "Download FL EAcord"}
                  </button>
                </a>
              </li>
            )}
          </ul>
          {(loadingEAcordNCCI || loadingEAcordCA || loadingEAcordFL) && (
            <>
              <span className="eAcordLoader">
                <SmallLoader />
              </span>
            </>
          )}
        </div>
      </div>
    </>
  );
};

// Export the memoized component
export default React.memo(DownloadEAcord);
